<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- 选项卡 -->
						<div class="navBox f-bct">
							<p class="a">Мои посылки</p>
							<p @click="back()">Вернись на последнюю страницу</p>
						</div>
						<!-- 筛选 -->
						<div class="shaixuan f-ct">
							<div class="l f-ct">
								<div class="itm">
									<span>Режим посылки</span>
									<el-select @change="courseOrderlist(1)" v-model="value" placeholder="Режим посылки">
									<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
									</el-select>
								</div>
								<div class="itm">
									<span style="width: 0.8rem;margin-right: 0.4rem;">код клиента</span>
									<el-select v-model="mtIdx1" placeholder="код клиента">
									<el-option
									v-for="item in mtList1"
									:key="item.value"
									:label="item.label"
									:value="item.value">
									</el-option>
									</el-select>
								</div>
								<div class="itm1">
									<el-image :src="require('@/static/icon29.png')"></el-image>
									<el-input type="text" v-model="keyword" placeholder="Введите номер, пожалуйста"></el-input>
								</div>
							</div>
							<div class="seachBtn f-ct">
								<div @click="courseOrderlist(1)">Поиск</div>
							</div>
						</div>
						<!-- 选择 -->
						<div class="rukuSel f-bct" v-if="value*1==1">
							<div class="f-ct">
								<div class="l f-ct" @click="selFALL">
									<el-image v-if="isSelSel" :src="require('@/static/icon28.png')"></el-image>
									<el-image v-else :src="require('@/static/icon27.png')"></el-image>
									<span>全选</span>
								</div>
							</div>
							<div class="seachBtn f-ct">
								<p>Избранный. {{isSelNub}} Посылка.</p>
								<div @click="goDabao()">Упаковать</div>
							</div>
						</div>
						<!-- 小包裹列表 -->
						<div class="smallList">
							<div class="itm" @click="link('/smallBagMsg',{id:item.id})" v-for="(item,index) in orderList">
								<div class="sn f-bct">
									<div class="t1 f-ct" @click.stop="selF(item)">
										<template v-if="value*1==1">
										<el-image v-if="item.isHave" :src="require('@/static/icon28.png')"></el-image>
										<el-image v-else :src="require('@/static/icon27.png')"></el-image>
										</template>
										单号：<span>{{item.expressNumber}}</span>
										<template>
											<p class="borMT"></p>
											<div class="manMT">n. маркировка：{{item.memberCode||'？'}}</div>
										</template>
									</div>
									<div class="t2" v-if="item.status==0">Недоступ</div>
									<div class="t2" v-if="item.status==1">В хранилище.</div>
									<div class="t2" v-if="item.status==2">Собирайся.</div>
									<div class="t2" v-if="item.status==3">Упакован.</div>
									<div class="t2" v-if="item.status==4">Отправлено.</div>
									<div class="t2" v-if="item.status==5">Доставлено.</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click.stop="showImgViewer(item.imageUrl)" v-if="item.imageUrl" :src="item.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon17.png')"></el-image>
													<p>длина：{{item.length||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon18.png')"></el-image>
													<p>ширина：{{item.width||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon19.png')"></el-image>
													<p>высота：{{item.height||'？'}}cm</p>
												</div>
												<div class="nubitm">
													<p>груз：{{item.name||'？'}}</p>
												</div>
											</div>
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon20.png')"></el-image>
													<p>объём：{{item.volume||'？'}}cm³</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon21.png')"></el-image>
													<p>Вес：{{item.weight||'？'}}kg</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon22.png')"></el-image>
													<p>небольшой：{{item.pieceNum}}пункт</p>
												</div>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==0" @click.stop="applyLookDetailF(item.id)">Запрос на просмотр пакета</p>
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==1">Подать заявку на просмотр пакета</p>
										<p class="t1" style="margin-bottom: 0.06rem;" v-if="item.lookDetailStatus==2" @click.stop="showImgViewer(item.lookDetailGallery,1)">Посмотреть пакет</p>
										
										<!-- <p class="t1" v-if="item.logisticsJson">Проверь логистику.</p> -->
										<p class="t2" @click.stop="hbDel1=true,delBigId=item.id" v-if="item.status==0">удалить</p>
										<p class="t3" @click.stop="link('/carMsg',{id:item.trainId})" v-if="item.status==4">Подробности по машине</p>
									</div>
								</div>
							</div>
						</div>
						<!-- 暂无 -->
						<div class="zw" v-if="!orderList.length">
							<el-image :src="require('@/static/zw1.png')"></el-image>
							<p class="t1">Пока никаких данных о маленьких пакетах</p>
						</div>
						<!-- 分页 -->
						<div class="fenye">
							<el-pagination
							background
							hide-on-single-page
							layout="prev, pager, next,jumper"
							@current-change="goPage"
							:page-size="pageSize"
							:total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" v-if="hbSubmitN"></div>
		<div class="subTips" style="height: 8rem;overflow-y: scroll;" v-if="hbSubmitN">
			<div class="title f-bct">
				<p>Консолидация</p>
				<el-image @click="hbSubmitN=false" :src="require('@/static/icon26.png')"></el-image>
			</div>
			<div class="dabaoFrom">
				<div class="selBox">
					<div class="lab">Индивидуальный код</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="personalCode" placeholder="Индивидуальный код"></el-input>
				</div>
				<!-- <div class="selBox">
					<div class="lab">选择唛头</div>
					<el-select v-model="mtIdx1" placeholder="请选择">
					<el-option
					v-for="item in mtList1"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
					</el-select>
					<el-image :src="require('@/static/icon30.png')"></el-image>
				</div> -->
				<div class="selBox">
					<div class="lab">Вид упаковки</div>
					<el-select v-model="valueDB" placeholder="Вид упаковки">
					<el-option
					v-for="item in optionsDB"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
					</el-select>
					<el-image :src="require('@/static/icon30.png')"></el-image>
				</div>
				
				<!-- <div class="selBox">
					<div class="lab">输运类型</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="transportType" placeholder="输运类型"></el-input>
				</div> -->
				<div class="selBox">
					<div class="lab">Скорость доставки</div>
					<el-select v-model="valueYs" placeholder="Скорость доставки">
					<el-option
					v-for="item in optionsYS"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
					</el-select>
					<el-image :src="require('@/static/icon30.png')"></el-image>
				</div>
				
				<div class="selBox">
					<div class="lab">Тип груза</div>
					<el-select v-model="freightTypeIdx" placeholder="Тип груза">
					<el-option
					v-for="item in freightTypeArr"
					:key="item.value"
					:label="item.label"
					:value="item.value">
					</el-option>
					</el-select>
					<el-image :src="require('@/static/icon30.png')"></el-image>
				</div>
				
				<!-- <div class="selBox">
					<div class="lab">Тип груза</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="freightType" placeholder="Тип груза"></el-input>
				</div> -->
				
				<div class="selBox">
					<div class="lab">Застраховать&emsp;$</div>
					<el-input style="width: calc(100% - 2rem);" type="number" v-model="insurance" placeholder="Себестоимость"></el-input>
				</div>
				
				
				<div class="selBox">
					<div class="lab">ФИО</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="fullName" placeholder="ФИО"></el-input>
				</div>
				<div class="selBox">
					<div class="lab">Ваш номер телефона</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="phone" placeholder="Ваш номер телефона"></el-input>
				</div>
				<div class="selBox">
					<div class="lab">Город доставки</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="expressName" placeholder="Город доставки"></el-input>
				</div>
				<div class="selBox">
					<div class="lab">Транспортная компания</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="transportCompany" placeholder="Транспортная компания"></el-input>
				</div>
				
				
				
				<div class="selBox">
					<div class="lab">примечание</div>
					<el-input style="width: calc(100% - 1rem);" type="text" v-model="remark" placeholder="Пожалуйста, введите примечание"></el-input>
					<!-- <el-image :src="require('@/static/icon30.png')"></el-image> -->
				</div>
				<div class="nubtips">Избранный. {{isSelNub}} Посылка номер Один：</div>
				<div class="snBox">
					<span v-for="item in selList">{{item.expressNumber}},</span>
				</div>
			</div>
			<div class="btnBox f-ct">
				<div class="b2" style="width: 274px;margin: 0;" @click="packageBigApplyPack()">Создать</div>
			</div>
		</div>
		<!-- 删除 -->
		<div class="maskBg" v-if="hbDel1"></div>
		<div class="subTips" style="width: 402px;" v-if="hbDel1">
			<el-image class="cha"  @click="hbDel1=false" :src="require('@/static/icon26.png')"></el-image>
			<div class="txt">Удалите приказ.</div>
			<div class="t1">Вы уверены, что хотите удалить этот приказ？</div>
			<div class="btnBox f-ct" style="margin-top: 30px;">
				<div class="b1" @click="hbDel1=false">вернут</div>
				<div class="b2" @click="packageMiniDelete">vt. определить</div>
			</div>
		</div>
		<!-- 图片预览 -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
import { packageMiniList,packageMiniDelete,
memberCodeList,
packageBigApplyPack,
applyLookDetail
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	components: {
		'leftBox': () => import('@/components/leftBox.vue'),
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
	},
	data(){
		return {
			imgViewerVisible:false,
			imgList:[],
			// 页面参数
			bannerIdx:0,
			hbSubmitN:false,
			hbDel1:false,
			keyword:'',
			options: [
				{
					value: '-1',label: 'pron. весь'
				},
				{
					value: '0',label: 'В пути на склад'
				},
				{
					value: '1',label: 'На складе'
				},
				{
					value: '2',label: 'В сборке'
				}, 
				{
					value: '3',label: 'Упаковано'
				}, 
				{
					value: '4',label: 'Отправлено'
				}, 
				{
					value: '5',label: 'Доставлено'
				},
			],
			value: '-1',
			// Способ упаковать вещи
			optionsDB: [
				{value: 'мешок и скотч',label: 'мешок и скотч'},
				{value: 'коробка',label: 'коробка'},
				{value: 'коробка+уголки',label: 'коробка+уголки'},
				{value: 'уголки',label: 'уголки'},
				{value: 'Обрешетка',label: 'Обрешетка'},
				{value: 'палета',label: 'палета'},
			],
			valueDB: 'палета',
			// 输运类型
			optionsYS: [
				{
					value: 'Доставка через Дальний восток от 30 и более дней (сборный груз, одежда опт, обувь опт)',
					label: 'Доставка через Дальний восток от 30 и более дней (сборный груз, одежда опт, обувь опт)',
				},
				{
					value: 'Быстрая доставка моно хоз',
					label: 'Быстрая доставка моно хоз',
				},
				{
					value: 'Медленная доставка моно хоз от 30 до 100кг',
					label: 'Медленная доставка моно хоз от 30 до 100кг',
				},
				{
					value: 'Доставка до Казахстана г. Алматы 7-10 дней (самовывоз)',
					label: 'Доставка до Казахстана г. Алматы 7-10 дней (самовывоз)',
				},
			],
			valueYs: 'Доставка до Казахстана г. Алматы 7-10 дней (самовывоз)',
			
			freightTypeArr:[
				
				{
					value: 'Моно хоз',
					label: 'Моно хоз',
				},
				{
					value: 'Хоз товары (только Казахстан самовывоз)',
					label: 'Хоз товары (только Казахстан самовывоз)',
				},
				{
					value: 'Сборный груз',
					label: 'Сборный груз',
				},
				{
					value: 'Одежда опт',
					label: 'Одежда опт',
				},
				{
					value: 'Обувь опт',
					label: 'Обувь опт',
				},
				{
					value: 'Фура с сумками',
					label: 'Фура с сумками',
				},
				{
					value: 'Фура с шапками',
					label: 'Фура с шапками',
				},
				{
					value: 'Носки от 30кг',
					label: 'Носки от 30кг',
				},
				{
					value: 'одежда розница',
					label: 'одежда розница',
				},
			],
			freightTypeIdx:'Моно хоз',
			
			remark:'',
			transportType:'',
			// freightType:'',
			insurance:'',
			
			personalCode:'',
			fullName:'',
			phone:'',
			expressName:'',
			transportCompany:'',
			// 分页
			orderList:[],
			pageNum:1,
			pageSize:10,
			total:40,
			// 删除
			delBigId:0,
			// 选择
			isSelNub:0,
			selList:[],
			// 唛头
			mtList:[],
			mtIdx:0,
			mtList1:[],
			mtIdx1:0,
		}
	},
	mounted() {
		this.value = this.$route.query.value||'-1'
		this.courseOrderlist()
		this.memberCodeList()
	},
	methods:{
		// 申请查看包裹
		async applyLookDetailF(id){
			const res = await applyLookDetail({id})
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.courseOrderlist()
			}else{this.Tips(res.msg)}
		},
		// 图片预览
		showImgViewer(url,type){
			this.imgList = [url]
			if(type){
				this.imgList = url
			}
			this.imgViewerVisible = true;
			const m = (e) => { e.preventDefault() };
		},
		closeImgViewer(){
			this.imgViewerVisible = false;
		},
		// 打开打包弹出框
		goDabao(){
			if(!this.selList.length){
				this.Tips('Пожалуйста, сначала выберите приказ')
				return
			}
			this.hbSubmitN = true
		},
		// 申请打包
		async packageBigApplyPack(){
			// if(!this.mtList.length){
			// 	this.Tips('请先添加唛头')
			// 	this.link('/maitouList')
			// 	return
			// }
			var packageMiniIdList = []
			var memberCodeId = ''
			this.selList.forEach((item)=>{
				packageMiniIdList.push(item.id)
				if(!memberCodeId){
					memberCodeId = item.memberCodeId
				}
			})
			var data = {
				memberCodeId:memberCodeId,
				packageMiniIdList,
				packType:this.valueDB,
				remark:this.remark,
				
				
				transportType:this.valueYs,
				freightType:this.freightTypeIdx,
				insurance:this.insurance,
				
				
				personalCode:this.personalCode,
				fullName:this.fullName,
				phone:this.phone,
				expressName:this.expressName,
				transportCompany:this.transportCompany,
				

			}
			// console.log(data)
			// return
			const res = await packageBigApplyPack(data)
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.selList = []
				this.isSelNub = 0
				this.courseOrderlist(1)
			}else{this.Tips(res.msg)}
		},
		// 唛头列表
		async memberCodeList(){
			const res = await memberCodeList({})
			if(res.code==200){
				var mtList = []
				var mtList1 = [{
					value:0,
					label:'全部',
				}]
				for(var i in res.rows){
					mtList.push({
						...res.rows[i],
						value:res.rows[i].id,
						label:res.rows[i].memberCode,
					})
					mtList1.push({
						...res.rows[i],
						value:res.rows[i].id,
						label:res.rows[i].memberCode,
					})
				}
				this.mtList = mtList
				this.mtList1 = mtList1
				this.mtIdx = res.rows[0].id
				this.mtIdx1 = 0
			}else{this.Tips(res.msg)}
		},
		// 单选
		selF(item){
			var selList = []
			var isHave = false
			var isHaveIdx = 0
			this.selList.forEach((i,idx)=>{
				selList.push(i)
				if(i.id==item.id){
					isHave=true
					isHaveIdx=idx
				}
			})
			if(isHave){
				selList.splice(isHaveIdx,1)
			}else{
				selList.push(item)
			}
			this.selList = selList
			this.isSelNub = selList.length
			this.isSel()
		},
		// 全选
		selFALL(){
			this.orderList.forEach((i)=>{
				this.selF(i)
			})
		},
		// 判断是否选择
		isSel(){
			this.orderList.forEach((i)=>{
				var isHave = false
				this.selList.forEach((j)=>{
					if(i.id==j.id){
						isHave=true
					}
				})
				i.isHave = isHave
			})
		},
		// 查询课程列表
		async courseOrderlist(def){
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			if(this.value*1 != -1){
				data.status = this.value*1
			}
			if(this.keyword){
				data.expressNumber = this.keyword
			}
			if(this.mtIdx1){
				data.memberCodeId = this.mtIdx1
			}
			let res = await packageMiniList(data);
			if(res.code==200){
				res.rows.forEach((item)=>{
					item.isHave = false
				})
				if(this.pageNum==1){
					this.total = res.total
				}
				this.orderList = res.rows
				this.isSel()
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			this.pageNum = e
			this.courseOrderlist()
		},
		// 小包裹删除
		async packageMiniDelete(){
			const res = await packageMiniDelete({id:this.delBigId})
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.hbDel1 = false
				this.courseOrderlist(1)
			}else{this.Tips(res.msg)}
		},
	},
	computed:{
		// 是否全选
		isSelSel(){
			var isall = true
			this.orderList.forEach((i)=>{
				var isHave = false
				this.selList.forEach((j)=>{
					if(i.id==j.id){
						isHave=true
					}
				})
				if(!isHave){
					isall =false
				}
			})
			return isall
		},
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pcon{
	padding: 0 74px;
	padding-bottom: 46px;
}
.banner{
	width: 100%;
	height: 413px;
	.el-image{
		width: 100%;
		height: 413px;
		border-radius: 18px;
	}
	.dian{
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		bottom: 16px;
		z-index: 2;
		div{
			margin: 0 3px;
			width: 8px;
			height: 8px;
			border-radius: 8px;
			background: #00000033;
			transition:0.3s;
		}
		.a{
			background: #fff;
			width: 14px;
			transition:0.3s;
		}
	}
}
.pageCon{
	margin-top: 32px;
	justify-content: space-between;
	.pageConL{
		width: 530px;
	}
	.pageConR{
		width: calc(100% - 562px);
		.userNub{
			.itm{
				width: 382px;
				height: 158px;
				border-radius: 12px;
				background: #fff;
				padding-right: 46px;
				padding-left: 36px;
				.el-image{
					width: 80px;
				}
				.txt{
					width: calc(100% - 90px);
					margin-right: 10px;
					.t1{
						font-size: 42px;
						font-weight: bold;
					}
					.t2{
						font-size: 20px;
						color: #666666;
					}
				}
			}
		}
		.listBox{
			.tit{
				.tl{
					display: flex;
					align-items: center;
					.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
					p{
						font-size: 18px;
						padding-left: 10px;
					}
				}
				.tr{
					display: flex;
					align-items: center;
					.el-image{
						width: 20px;
					}
					p{
						font-size: 16px;
						color: #666666;
					}
				}
			}
			.zw{
				padding-top: 0;
				.el-image{
					margin-bottom: 0;
				}
			}
			.smallBox{
				width: 100%;
				// height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.smallList{
					margin-top: 16px;
					// height: 340px;
					// background: pink;
					// overflow: scroll;
					.itm{
						border: 1px solid #EFF1F6;
						border-radius: 8rpx;
						margin-bottom: 16px;
						.sn{
							height: 56px;
							border-bottom: 1px solid #EFF1F6;
							background: #EFF1F6;
							padding: 0 24px;
							.el-image{
								display: block;
								width: 20px;
								margin-right: 12px;
								// margin-left: 24px;
							}
							.t1{
								font-size: 16px;
								color: #999999;
								span{
									color: #333;
								}
							}
							.t3{
								.snTxt{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.bor{
									width: 1px;
									height: 16px;
									background: #D9D9D9;
									margin: 0 24px;
								}
								.man{
									font-size: 16px;
								}
							}
							.t2{
								// width: 72px;
								padding: 0 6px;
								height: 30px;
								background: #C7F3F5;
								font-size: 14px;
								color: #38ABB0;
								text-align: center;
								line-height: 30px;
								border-radius: 4px;
							}
						}
						.detail{
							padding: 16px 0;
							.msg{
								width: calc(100% - 125px);
								padding-left: 24px;
								// background: pink;
								.img{
									width: 66px;
									height: 66px;
									border-radius: 6px;
									margin-right: 16px;
								}
								.r{
									width: calc(100% - 82px);
									.cBox{
										margin-bottom: 10px;
										&:last-child{
											margin-bottom: 0;
										}
									}
									.nubitm{
										display: flex;
										align-items: center;
										// margin-right: 63px;
										width: 176px;
										.el-image{
											width: 20px;
											height: 20px;
											margin-right: 6px;
										}
										p{
											font-size: 16px;
										}
									}
								}
							}
							.bor{
								width: 1px;
								height: 50px;
								background: #D9D9D9;
							}
							.caozuo{
								width: 124px;
								padding: 0 6px;
								// background: #00000033;
								p{
									text-align: center;font-size: 14px;
									cursor: pointer;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
									margin-top: 6px;
								}
								.t3{
									color: #38ABB0;
									margin-top: 6px;
								}
							}
						}
					}
				}
			}
			.mtBox{
				width: 382px;
				height: 411px;
				background: #fff;
				border-radius: 12px;
				padding: 24px;
				.maitouList{
					margin-top: 16px;
					height: 330px;
					// background: pink;
					overflow: scroll;
					.mtItm{
						margin-bottom: 22px;
						.l{
							.nub{
								// width: 20px;
								height: 20px;
								background: #38ABB0;
								margin-right: 12px;
								color: #fff;
								border-radius: 20px;
								font-size: 13px;
								text-align: center;
								line-height: 19px;
								padding: 0 5px;
								padding-left: 6px;
							}
							.el-image{
								width: 45px;
							}
							p{
								font-size: 16px;
								padding-left: 6px;
							}
						}
						.r{
							display: flex;
							align-items: center;justify-content: flex-end;
							.bor{
								width: 1px;
								height: 16px;
								margin: 0 10px;
								background: #D9D9D9;
							}
							.btnItm{
								display: flex;
								align-items: center;
								.el-image{
									width: 14px;
									margin-right: 4px;
								}
								p{
									font-size: 14px;
								}
								.t1{
									color: #38ABB0;
								}
								.t2{
									color: #FF4D5A;
								}
							}
						}
					}
				}
				.tableImgList{
					margin-top: 16px;
					height: 340px;
					// background: pink;
					overflow: scroll;
					.el-image{
						width: 100%;
						height: 154px;
						margin-bottom: 16px;
						border-radius: 12px;
					}
				}
			}
		}
	}
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	padding-left: 0;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
		.itm1{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			border: 1px solid #DDDDDD;
			border-radius: 4px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
			::v-deep .el-input__inner{
				background: none;
				border: none;
				padding-left: 0;
			}
			.el-image{
				display: block;
				width: 16px;
				margin-left: 16px;
				margin-right: 12px;
			}
		}
	}
	.seachBtn{
		transform: translateX(-12px);
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
}
.rukuSel{
	.itm{
		display: flex;
		align-items: center;
		font-size: 16px;
		margin-left: 31px;
		span{
			display: block;
			width: 90px;
			padding-right: 16px;
		}
	}
	.l{
		.el-image{
			width: 20px;
			margin-right: 12px;
		}
		span{
			font-size: 14px;
		}
	}
	.seachBtn{
		p{
			font-size: 14px;
			padding-right: 16px;
		}
		div{
			width: 128px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
		}
	}
}
.navBox{
	border-bottom: 1px solid #EEEEEE;
	// padding: 0 10px;
	p{
		// padding-top: 24px;
		padding-bottom: 16px;
		// margin-right: 56px;
		font-size: 18px;
		cursor: pointer;
		color: #7D7D89;
		&::after{
			position: absolute;
			content: '';
			width: 0%;
			height: 4px;
			border-radius: 4px;
			background: #38ABB0;
			bottom: 0%;
			left: 50%;
			transform: translateX(-50%);
			transition:0.3s;
		}
	}
	.a{
		color: #38ABB0;
		font-weight: bold;
		&::after{
			width: 100%;
			transition:0.3s;
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 26px;
}
::v-deep .active{
	background: #38ABB0!important;
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 764px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.title{
		height: 69px;
		padding: 0 30px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		margin-bottom: 40px;
		.el-image{
			width: 14px;
		}
		p{
			font-size: 18px;
		}
	}
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.txt{
		font-size: 18px;
		font-weight: 600;
		color: #2F3541;
		margin-top: 35px;
		text-align: center;
	}
	.t1{
		font-size: 18px;
		color: #7D7D89;
		// font-weight: 600;
		text-align: center;
		margin-top: 25px;
		span{
			color: #38ABB0;
			padding: 0 4px;
		}
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.dabaoFrom{
		.selBox{
			width: 95%;
			margin: auto;
			border-radius: 6px;
			margin-bottom: 20px;
			height: 56px;
			border: 1px solid #DDDDDD;
			padding-left: 16px;
			padding-right: 24px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.el-select{
				// background: pink;
				width: calc(100% - 100px);
			}
			::v-deep .el-input__inner{
				border: none;
				text-align: right;padding: 0;
			}
			::v-deep .el-input__suffix{
				display: none;
			}
			.lab{
				font-size: 14px;
			}
			.el-image{
				width: 10px;
				margin-left: 16px;
			}
		}
	}
	.nubtips{
		width: 95%;
		margin: auto;
		color: #FF4D5A;
		font-size: 14px;
	}
	.snBox{
		width: 95%;
		margin: auto;
		background: #F6F6F6;
		height: 142px;
		overflow: scroll;
		padding: 16px 20px;
		border-radius: 6px;
		margin-top: 16px;
		font-size: 14px;
	}
	.iptBox{
		width: 403px;
		margin: auto;
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.lab{
			font-size: 16px;
			color: #9A9DA7;
			width: calc(100% - 307px);
		}
		.ipt{
			width: 307px;
			border: 1px solid #E8EDF4;
			border-radius: 8px;
			padding: 0 20px;
			height: 50px;
			display: flex;
			align-items: center;
			::v-deep .el-input__inner{
				border: none;
				padding: 0 0;
				font-size: 0.16rem;
				background: none;
			}
			.selItm{
				display: flex;
				align-items: center;
				margin-right: 80px;
				.el-image{
					width: 20px;
					margin-right: 8px;
				}
				p{
					font-size: 16px;
				}
			}
		}
	}
	.btnBox{
		margin-top: 42px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #F6F6F6;
			color: #666;
		}
		.b2{
			background: #38ABB0;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>